import { Route } from 'types/route.type';
import ViewShrimpDataUpload from './view-shrimp-data-upload';

export const routes: Route[] = [
  {
    path: '/shrimp-upload',
    component: ViewShrimpDataUpload,
    id: 'shrimpDataUpload.navigation.viewShrimpDataUpload'
  },
];
